import 'babel-polyfill';

import Vue from 'vue';
import VueRouter from 'vue-router';

import Headbar from './components/Headbar';
import Footbar from './components/Footbar';

import Home from './pages/Home';
import FAQ from './pages/FAQ';
import Feedback from './pages/Feedback';
import Contact from './pages/Contact';
import Interior from './pages/Interior';
import Treatment from './pages/Treatment';
import PressurePoint from './pages/PressurePoint';

import Firebase from 'firebase/app';
import 'firebase/database'

Vue.use(VueRouter);

const routes = [
  { path: '/', component: Home },
  { path: '/home', component: Home },
  { path: '/faq', component: FAQ },
  { path: '/contact', component: Contact },
  { path: '/feedback', component: Feedback },
  { path: '/interior', component: Interior },
  { path: '/treatment', component: Treatment },
  { path: '/pressure-point', component: PressurePoint },
];

const router = new VueRouter({
  routes,
});

const app = new Vue({
  router,
  components: {
    'headbar': Headbar,
    'footbar': Footbar,
  },
  data() {
    return {
      firebaseApp: Firebase.initializeApp({databaseURL: "https://todaseitai-prod.firebaseio.com/",}),
    };
  }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/js/app.js